//job-report.js
import React, { useEffect } from 'react'

const JobReport = () => {
	return <div>JobReport</div>
}

export default JobReport
